import DashboardVerified from '@widgets/dashboard/DashboardVerified';
import DashboardUnverified from '@widgets/dashboard/DashboardUnverified';
import DashboardFrozen from '@widgets/dashboard/DashboardFrozen';
import { useSelector } from 'react-redux';

export default function DashboardPage() {
  const { isUnverified, isFrozen } = useSelector((state) => state.user);

  if (isUnverified) {
    return <DashboardUnverified />;
  }

  if (isFrozen) {
    return <DashboardFrozen />;
  }

  return <DashboardVerified />;
}

//если топ ап сделан для тестовой, то можно получить сенситив дату
//проверить список банков получения для не онбординг
